<script setup lang="ts">
// import logo from "/comercia_vertical.webp"

const appName = import.meta.env.VITE_APP_NAME ?? "People Hub+"
</script>

<template>
  <div class="grid flex-1 py-2 text-left text-sm">
    <span
      class="text-primary mb-0.5 truncate font-sans text-2xl leading-tight font-semibold"
    >
      {{ appName }}
    </span>
  </div>
</template>
